var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isActive
    ? _c("gg-modal", {
        attrs: {
          "is-active": _vm.isActive
        },
        on: {
          close: _vm.closeModal
        },
        scopedSlots: _vm._u(
          [
            {
              key: "toolbar",
              fn: function fn() {
                return [_vm._v(" Create Staging ")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function fn() {
                return [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c(
                            "gg-input-label",
                            {
                              staticClass: "d-block pb-1"
                            },
                            [_vm._v(" Select domain ")]
                          ),
                          _c("domain-select", {
                            attrs: {
                              remote_domain: _vm.selectedDomainGetter,
                              outlined: "",
                              "no-label": ""
                            },
                            on: {
                              input: _vm.setDomain
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              label: "Directory"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append-outer",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "300"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref) {
                                                  var on = _ref.on
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g({}, on),
                                                      [
                                                        _vm._v(
                                                          " mdi-help-circle-outline "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            73716224
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " The directory is relative to your domain and "
                                          ),
                                          _c("b", [_vm._v("should not exist")]),
                                          _vm._v(
                                            ". e.g. To install at http://mydomain/dir/ just type "
                                          ),
                                          _c("b", [_vm._v("dir")]),
                                          _vm._v(
                                            ". To install only in http://mydomain/ leave this empty. "
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1727262071
                            ),
                            model: {
                              value: _vm.model.softdirectory,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "softdirectory", $$v)
                              },
                              expression: "model.softdirectory"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.selectedService
                        ? _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:7",
                                    expression: "'required|max:7'"
                                  }
                                ],
                                attrs: {
                                  label: "Database name",
                                  prefix: _vm.selectedService.dbprefix,
                                  name: "database",
                                  "error-messages": _vm.errors.collect(
                                    "database"
                                  ),
                                  "data-vv-as": "Database Name"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append-outer",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                bottom: "",
                                                "max-width": "300"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref2) {
                                                      var on = _ref2.on
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              " mdi-help-circle-outline "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                73716224
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " Type the name of the database to be created for the installation "
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1454241435
                                ),
                                model: {
                                  value: _vm.model.softdb,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.model, "softdb", $$v)
                                  },
                                  expression: "model.softdb"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              label: "Site name",
                              name: "sitename",
                              "error-messages": _vm.errors.collect("sitename"),
                              "data-vv-as": "Site Name"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append-outer",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "300"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref3) {
                                                  var on = _ref3.on
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g({}, on),
                                                      [
                                                        _vm._v(
                                                          " mdi-help-circle-outline "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            73716224
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " Enter Site Name for your new site. If you want to use the same site name as the source site leave this field blank. "
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              4119014956
                            ),
                            model: {
                              value: _vm.model.site_name,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "site_name", $$v)
                              },
                              expression: "model.site_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Disable Search Engine Visibility",
                              "true-value": "off",
                              "false-value": "on"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "max-width": "300"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref4) {
                                                  var on = _ref4.on
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g({}, on),
                                                      [
                                                        _vm._v(
                                                          " mdi-help-circle-outline "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            73716224
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " If checked then this shall discourage search engines from indexing this site. It is up to search engines to honor this request. "
                                          )
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1787873199
                            ),
                            model: {
                              value: _vm.model.no_search_engine,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "no_search_engine", $$v)
                              },
                              expression: "model.no_search_engine"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "actions",
              fn: function fn() {
                return [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: _vm.closeModal
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        loading: _vm.loading,
                        disabled: _vm.loading
                      },
                      on: {
                        click: _vm.setStage
                      }
                    },
                    [_vm._v("Create")]
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          2520867795
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }